import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=19bbed1a&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=ts&"
export * from "./settings.vue?vue&type=script&lang=ts&"
import style0 from "./settings.vue?vue&type=style&index=0&id=19bbed1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbed1a",
  null
  
)

export default component.exports